/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestigationLockReleaseByIncidentResponse
 */
export interface InvestigationLockReleaseByIncidentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationLockReleaseByIncidentResponse
     */
    success?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvestigationLockReleaseByIncidentResponse
     */
    releasedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLockReleaseByIncidentResponse
     */
    incidentId?: string;
}

/**
 * Check if a given object implements the InvestigationLockReleaseByIncidentResponse interface.
 */
export function instanceOfInvestigationLockReleaseByIncidentResponse(value: object): value is InvestigationLockReleaseByIncidentResponse {
    return true;
}

export function InvestigationLockReleaseByIncidentResponseFromJSON(json: any): InvestigationLockReleaseByIncidentResponse {
    return InvestigationLockReleaseByIncidentResponseFromJSONTyped(json, false);
}

export function InvestigationLockReleaseByIncidentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestigationLockReleaseByIncidentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'releasedCount': json['releasedCount'] == null ? undefined : json['releasedCount'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
    };
}

export function InvestigationLockReleaseByIncidentResponseToJSON(json: any): InvestigationLockReleaseByIncidentResponse {
    return InvestigationLockReleaseByIncidentResponseToJSONTyped(json, false);
}

export function InvestigationLockReleaseByIncidentResponseToJSONTyped(value?: InvestigationLockReleaseByIncidentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'releasedCount': value['releasedCount'],
        'incidentId': value['incidentId'],
    };
}

